export class GA4Provider {
  static send(eventName: string, params: Record<string, any> = {}) {
    if (typeof window.gtag !== 'function') {
      console.warn('[GA4] gtag not loaded');
      return;
    }

    window.gtag('event', eventName, params);
    //   if (import.meta.env.DEV) {
    //     console.log(`[GA4] ${eventName}`, params);
    //   }
  }
}
